import { BaseSelect, Select, SelectProps } from '@app/components';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { PromotionConditionType } from '@app/common';
import React from 'react';

const columnHelper = createColumnHelper<PromotionConditionType>();

export const getLabel = (type: PromotionConditionType) => {
  switch (type) {
    case PromotionConditionType.BIRTHDAY_WINDOW:
      return "Anniversaire";
    case PromotionConditionType.ORDER_TOTAL:
      return "Montant de la commande";
    case PromotionConditionType.PACKS:
      return "Menu requis";
    case PromotionConditionType.PRODUCT_VARIATIONS:
      return "Produits requis";
    case PromotionConditionType.CUSTOMERS:
      return "Clients ciblés";
    // case PromotionConditionType.TAGS:
    //   return "Catégories requises";
    // case PromotionConditionType.CUSTOMER_ORDER_TOTAL:
    //   return "Nombre de commandes";
  }
}

const columns = [
  columnHelper.display({
    id: 'type',
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Type
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => {
      return <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {getLabel(info.row.original)}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    },
  }),
];

export const PromotionConditionSelect = ({ label = 'Type de condition', ...props }: Omit<SelectProps<any>, 'table'>) => {
  const table = useReactTable({
    data: Object.values(PromotionConditionType),
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Select
      label={label}
      table={table}
      transform={{
        accessor: (item) => item,
        value: (item) => item,
        display: (item) => getLabel(item)
      }}
      {...props} />
  );
};
